// extracted by mini-css-extract-plugin
export default {"main-layout":"W5AYt","mainLayout":"W5AYt","main":"JDLyB","skeleton-placeholder-pulse":"jm7jY","skeletonPlaceholderPulse":"jm7jY"};